import parserData from './_parserdata.js';
import bindKey from '../bindnode/_bindkey.js';
import forEach from '../_helpers/foreach.js';
var textNodeBinder = {
  setValue: function setValue(value) {
    this.textContent = typeof value === 'undefined' ? '' : value;
  }
};
export default function processTextNode(_ref) {
  var object = _ref.object,
    node = _ref.node,
    textNode = _ref.textNode,
    eventOptions = _ref.eventOptions;
  var bindingReg = parserData.bindingReg;
  var textContent = textNode.textContent;
  var _window = window,
    document = _window.document;
  bindingReg.lastIndex = 0;
  // tokens variable contains normal text as odd items
  // and bound keys as even items
  // 'foo{{x}}bar{{y}}baz{{z}}' -> ['foo', 'x', 'bar', 'y', 'baz', 'z', '']
  var tokens = textContent.split(bindingReg);
  // fragment contains all new text nodes
  var fragment = document.createDocumentFragment();
  forEach(tokens, function (token, index) {
    if (token) {
      var newTextNode = document.createTextNode(token);
      fragment.appendChild(newTextNode);
      // if tokens item is even then it is a key
      // which needs to be bound to newly created text node
      if (index % 2 !== 0) {
        bindKey(object, token, newTextNode, textNodeBinder, eventOptions);
      }
    }
  });
  node.insertBefore(fragment, textNode);
  node.removeChild(textNode);
}